import { Suspense } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { isSupportedLanguage } from '@app/i18n/languages';
import { PageLoader } from '@shared/components/PageLoader';
import { LanguageBoundary } from '@shared/i18n/LanguageBoundary';

export const LocalizedRoutes = () => {
  const { lng } = useParams();

  if (!isSupportedLanguage(lng)) {
    return <Navigate to="/es" replace />;
  }

  return (
    <LanguageBoundary language={lng}>
      <Suspense fallback={<PageLoader />}>
        <Outlet />
      </Suspense>
    </LanguageBoundary>
  );
};
